import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownButton,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import "./MultiSelectDropdown.css";

const MultiSelectDropdown = ({ options, onSelect }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [allSelected, setAllSelected] = useState(false);

  const handleSelect = (eventKey) => {
    const option = options.find((opt) => opt.value === eventKey);
    const isSelected = selectedOptions.includes(option);

    if (isSelected) {
      const options = selectedOptions.filter((opt) => opt !== option);
      setSelectedOptions(options);
      onSelect(options);
    } else {
      const options = [...selectedOptions, option];
      setSelectedOptions(options);
      onSelect(options);
    }
  };

  const handleSelectAll = () => {
    if (allSelected) {
      onSelect([]);
      setSelectedOptions([]);
    } else {
      setSelectedOptions(options);
      onSelect(options);
    }
    setAllSelected(!allSelected);
  };

  useEffect(() => {
    if (selectedOptions) {
      if (selectedOptions.length === options.length) {
        setAllSelected(true);
      } else {
        setAllSelected(false);
      }
    }
  }, [selectedOptions]);
  return (
    <DropdownButton
      id="dropdown-basic-button"
      title="Select Options"
      variant="secondary"
      className="multi-select-dropdown"
    >
      <Dropdown.Item as="button" onClick={handleSelectAll}>
        <Form.Check
          type="checkbox"
          label="Select All"
          checked={allSelected}
          onChange={handleSelectAll}
        />
      </Dropdown.Item>
      <Dropdown.Divider />
      {options?.map((option) => (
        <OverlayTrigger
          key={option.value}
          placement="left"
          overlay={
            <Tooltip id={`tooltip-${option.value}`}>{option.label}</Tooltip>
          }
        >
          <Dropdown.Item
            as="button"
            key={option.value}
            eventKey={option.value}
            onClick={() => handleSelect(option.value)}
            className="dropdown-item"
          >
            <Form.Check
              type="checkbox"
              label={option.label}
              checked={selectedOptions.includes(option)}
              onChange={() => handleSelect(option.value)}
              className="form-check-label"
            />
          </Dropdown.Item>
        </OverlayTrigger>
      ))}
    </DropdownButton>
  );
};

export default MultiSelectDropdown;
